import React from 'react';
// import jQuery from 'jquery';
import { BASEURL } from '../../../constant';

import {Helmet} from "react-helmet";

class head extends React.Component {

    constructor(props) {
        super(props);
        //const { history } = this.props;
        this.state = {
            logged: localStorage.getItem("authentication"),
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            logged_user_name: ''
        };
    }


    logoutFunc(e) {
        e.preventDefault();
        this.props.logoutSubmit();
    }
    logoutSess(e) {
        localStorage.clear();
        setTimeout(function () {
            window.location = "/";
        }, 1000);
    }
    componentDidMount() {
       
    }

    render() {
        return (
              
            <React.Fragment>
                <div class="container exclpartners">
                    <nav class="navbar navbar-inverse">
                         <div class="navbar-header">
                            <button type="button" data-target="#navbarCollapse" data-toggle="collapse" class="navbar-toggle">
                                <span class="sr-only">Toggle navigation</span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                            </button>
                            <a href="#" class="navbar-brand"><img src={'/assets/bewiseLogo.png'} alt='logo'
                            // className='profile-round mCS_img_loaded' 
                            /></a>
                        </div>
                      
                        <div id="navbarCollapse" class="collapse navbar-collapse">
                            <ul class="nav navbar-nav">
                                <li class="active"><a href="#">Dashboard</a></li>
                                <li><a href="#">Profile</a></li>
                                <li class="dropdown">
                                    <a data-toggle="dropdown" class="dropdown-toggle" href="#">Activities <b class="caret"></b></a>
                                    <ul class="dropdown-menu">
                                        <li><a href="#">Create</a></li>
                                        <li><a href="#">View</a></li>
                                        <li><a href="#">Reports</a></li>
                                        <li><a href="#">Contact</a></li>                                    </ul>
                                </li>
                            </ul>
                            <form class="navbar-form navbar-left">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Search" />
                                    <span class="input-group-btn">
                                        <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-search"></span></button>
                                    </span>
                                </div>
                            </form>
                            <ul class="nav navbar-nav navbar-right">
                                <li><span class='subtitleexcl'>Exclusive Partnerships</span></li>
                                <li><a href="#">Logout</a></li>
                            </ul>
                        </div>
                </nav>
            </div>
            </React.Fragment>

        )
    }
}
export default head;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveparnter/head.jsx